import $ from 'jquery';

$('body').on('click', '.table-expanded td:not(.tr-expand)', function (e) {
    const $tr = $(e.currentTarget).parent();
    window.location = $tr.attr('data-navigate-url');
});

$('body').on('click', '.tr-expand', function (e) {
    const $td = $(e.currentTarget);
    const $i = $td.find('i');

    if ($i.hasClass('bi-chevron-down')) {
        $i.removeClass('');
    }

    $i.toggleClass(function () {
        if ($(this).hasClass('bi-chevron-right')) {
            $(this).removeClass('bi-chevron-right');
            return 'bi-chevron-down';
        } else {
            $(this).removeClass('bi-chevron-down');
            return 'bi-chevron-right';
        }
    });

    const $tr = $td.parent();
    $tr.next().toggleClass('hidden-row');
});
